import request, { IWorkspaceResponse } from '/@/api/http/request'

// DRC 链路
const DICT_API_PREFIX = '/manage/api/v1'

export interface DictParam {
    id: number
    dict_code: string
    dict_name: string
    is_tree: number
    remark: string
}

export interface DictQueryParam {
    dict_code: string
    dict_name: string
}

export interface DictPageRequest {
    page: number
    page_size: number
    param: DictQueryParam
}

// 字典数据类型
export interface DictData {
  id: number
  dict_code: string
  dict_label: string
  dict_value: string
  parent_id: number
  status: number
  sort: number
  remark: string
}

// 通过父节点查列表
export interface parentData {
  parent_id: number
  dict_code: string
}

// 通过父节点查询接口
export const getParentParam = async function (dictCode: string, parentId: number): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/dict-sub-by-parent-id/${dictCode}/${parentId}`
  const result = await request.get(url)
  return result.data
}

/**
 * 分页接口
 * @param body
 * @returns
 */
export const getDictPage = async function (body: DictPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/dict-page`
  const result = await request.post(url, body)
  return result.data
}

/**
 *
 * @param body 添加字典类型接口
 * @returns
 */
export const addDict = async function (body: DictParam): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/save-dict`
  const result = await request.post(url, body)
  return result.data
}

/**
 *
 * @param body 编辑字典类型接口
 * @returns
 */
export const updateDict = async function (body: DictParam): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/update-dict`
  const result = await request.post(url, body)
  return result.data
}

export const deleteDict = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/delete-dict/${id}`
  const result = await request.delete(url)
  return result.data
}

// 获取字典数据列表
export const getDictDataList = async function (dictCode: string): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/dict-sub-by-code/${dictCode}`
  const result = await request.get(url)
  return result.data
}

// 获取字典数据树结构列表
export const getDictDataTree = async function (dictCode: string): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/dict-sub-tree-by-code/${dictCode}`
  const result = await request.get(url)
  return result.data
}

// 根据字典类型编码获取字典数据第一层
export const getDictDataTreeFirstData = async function (dictCode: string): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/dict-sub-tree-first-by-code/${dictCode}`
  const result = await request.get(url)
  return result.data
}

// 根据字典类型编码和父节点id获取下级数据
export const getDictTreeDataByParentId = async function (dictCode: string, parentId : number): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/dict-sub-by-parent-id/${dictCode}/${parentId}`
  const result = await request.get(url)
  return result.data
}

// 新增字典数据
export const addDictData = async function (body: DictData): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/save-dict-sub`
  const result = await request.post(url, body)
  return result.data
}

// 编辑字典数据
export const updateDictData = async function (body: DictData): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/update-dict-sub`
  const result = await request.post(url, body)
  return result.data
}

// 删除字典数据
export const deleteDictData = async function (id: number): Promise<IWorkspaceResponse<any>> {
  const url = `${DICT_API_PREFIX}/dict/delete-dict-sub/${id}`
  const result = await request.delete(url)
  return result.data
}
